import type { BanEntityType } from "../pages/administration/banData";

export interface ContextBanEntity { entity_type: BanEntityType; entity_value: string; }

/** Only exact, supported values may be prefilled from another screen. */
export const contextBanEntity = (type: unknown, raw: unknown): ContextBanEntity | null => {
	const value = typeof raw === "string" ? raw.trim() : type === "bin" && Number.isSafeInteger(raw) ? String(raw) : "";
	// eslint-disable-next-line no-control-regex -- Reject invalid control characters in external data.
	if (!value || /[\u0000-\u001f\u007f]/.test(value)) return null;
	// Explicit token source; generic card values may be PANs or masks.
	if (type === "card_token" && !/[\s*•…]|\.{2}/.test(value)) return { entity_type: "card", entity_value: value };
	if (type === "email" && value.length <= 254 && /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(value)) return { entity_type: type, entity_value: value };
	if (type === "bin" && /^(\d{6}|\d{8})$/.test(value)) return { entity_type: type, entity_value: value };
	if (type === "iban" && /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(value)) return { entity_type: type, entity_value: value };
	if (type === "country" && /^[a-z]{2}$/i.test(value) && !/^(xx|zz)$/i.test(value)) {
		const code = value.toUpperCase();
		try { if (new Intl.DisplayNames(["en"], { type: "region", fallback: "none" }).of(code === "UK" ? "GB" : code)) return { entity_type: type, entity_value: code }; } catch { return null; }
	}
	if (type === "ip") {
		const ipv4 = /^\d{1,3}(\.\d{1,3}){3}$/.test(value) && value.split(".").every(part => Number(part) <= 255);
		let ipv6 = false;
		if (value.includes(":") && /^[\da-f:.]+$/i.test(value)) {
			try { ipv6 = new URL(`http://[${value}]/`).hostname.startsWith("["); } catch { /* Invalid IPv6. */ }
		}
		if (ipv4 || ipv6) return { entity_type: type, entity_value: value };
	}
	// A bank/institution is not a ban type. Card bans require an explicit token source.
	return null;
};
